import { Button } from 'reactstrap'
import { FaListAlt } from 'react-icons/fa'
import { publishEvent } from '../../utils'
import { hasSidebar } from '../../utils'


export default function SidebarButton() {
  console.log('SidebarButton rendered')

  function clicked() {
    console.log('SidebarButton: clicked')
    publishEvent('SIDEBAR', {}, 'SidebarButton: clicked')
  }

  if (hasSidebar()) {
    return (
      <Button style={{ marginLeft: '8px'}} color="primary" onClick={clicked} data-cy="navbar-sidebar-button">
        < FaListAlt style={{ width: '1.25rem', height: '1.25rem' }} />
      </Button >
    )
  }
  return ''
}
